module.exports = __webpack_public_path__ + "media/images/Detetive_Nini-c2cab9dc6d25c91ca0518a865a9f5714.png";